<header></header>
<main>
    <div id="loadingSpinner">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
    <router-outlet></router-outlet>
</main>
<footer></footer>